import React from 'react';
interface Props {
  fillColor?: string;
}
function OccupationalIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="17"
      viewBox="0 0 20 17"
      fill="none">
      <g clipPath="url(#clip0_851_3616)">
        <path
          d="M5.71836 0.614844L0.218359 6.11484C-0.0753906 6.40859 -0.0753906 6.88359 0.218359 7.17422C0.512109 7.46484 0.987109 7.46797 1.27773 7.17422L1.74648 6.70547L6.30898 11.2648C6.36836 11.3242 6.42773 11.3773 6.49023 11.4305L6.59961 11.3211C6.63398 11.2867 6.65586 11.2461 6.66836 11.1992L6.97773 9.81172L2.80898 5.64609L5.24961 3.20547L8.24023 6.19609C8.29961 6.12734 8.36211 6.06172 8.42461 5.99609L9.29336 5.12734L6.30898 2.14609L6.77773 1.67734C7.07148 1.38359 7.07148 0.908594 6.77773 0.617969C6.48398 0.327344 6.00898 0.324219 5.71836 0.617969V0.614844ZM12.5621 12.9805L11.7121 13.168L14.7184 16.1773C15.0121 16.4711 15.4871 16.4711 15.7777 16.1773C16.0684 15.8836 16.0715 15.4086 15.7777 15.118L13.3652 12.7055C13.109 12.8273 12.8402 12.9211 12.559 12.9836L12.5621 12.9805ZM13.2184 0.614844C12.9246 0.908594 12.9246 1.38359 13.2184 1.67422L18.7184 7.17734C19.0121 7.47109 19.4871 7.47109 19.7777 7.17734C20.0684 6.88359 20.0715 6.40859 19.7777 6.11797L14.2809 0.614844C13.9871 0.321094 13.5121 0.321094 13.2215 0.614844H13.2184ZM12.9809 2.85234L9.13086 6.70547C8.76211 7.07422 8.50586 7.54297 8.39023 8.05234L7.64336 11.4148C7.59023 11.6461 7.47461 11.8586 7.30586 12.0273L4.21836 15.1148C3.92461 15.4086 3.92461 15.8836 4.21836 16.1742C4.51211 16.4648 4.98711 16.468 5.27773 16.1742L8.36523 13.0867C8.53398 12.918 8.74648 12.8023 8.97773 12.7492L12.3434 12.0055C12.8527 11.893 13.3215 11.6367 13.6902 11.2648L17.5434 7.41484L16.484 6.35547L14.2496 8.58672L11.809 6.14609L14.0402 3.91484L12.9809 2.85234ZM10.1934 7.76484L10.7496 7.20547L13.1902 9.64609L12.634 10.2055C12.4652 10.3742 12.2527 10.4898 12.0215 10.543L9.24023 11.1617L9.85898 8.38047C9.91211 8.14922 10.0277 7.93672 10.1965 7.76797L10.1934 7.76484Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3616">
          <rect
            width="20"
            height="16"
            fill="white"
            transform="translate(0 0.394531)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default OccupationalIcon;
